export type {
	SearchState,
	SearchResults,
	PortalSearchResult,
	KnowledgeBaseSearchResult,
	RequestTypeSearchResult,
	KnowledgeArticle,
} from './reducer';
export { default as searchReducer } from './reducer';
